import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import DayPicker from '../../core/components/DayPicker'
import TimeRangePicker from '../../core/components/TimeRangePicker'
import LoaderButton from '../../core/components/LoaderButton'
import {SCHEDULE_INTERVENTION_CMD_UPDATED, sendScheduleInterventionCmd, loadTicket} from '../actions'
import {ScheduleInterventionCmd} from '../models'
import i18n from '../i18n'
import style from './ScheduleInterventionModal.less'


class ScheduleInterventionModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props
        
        return dispatch(sendScheduleInterventionCmd()).then(() => {
            return dispatch(loadTicket())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, onHide, ...others} = this.props

        const dateField = (form) => {
            const value = form.value && (form.value.startDate || form.value.endDate)

            const onChange = (value) => {
                const previousStartDate = form.value && form.value.startDate
                const previousEndDate = form.value && form.value.endDate
                const nextStartDate = previousStartDate && new Date(value.getFullYear(), value.getMonth(), value.getDate(), previousStartDate.getHours()) || value
                const nextEndDate = previousEndDate && new Date(value.getFullYear(), value.getMonth(), value.getDate(), previousEndDate.getHours()) || value
                const nextValue = {startDate: nextStartDate, endDate: nextEndDate}
                form.onChange(nextValue)
            }

            return {value, onChange}
        }

        const dateRangeField = (form) => {
            const value = {
                from: form.value && form.value.startDate,
                to: form.value && form.value.endDate
            }

            const onChange = (value) => {
                const nextValue = {startDate: value && value.from, endDate: value && value.to}
                form.onChange(nextValue)
            }

            return {value, onChange}
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.scheduleIntervention}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.dateTimePicker}>
                        <div className={style.container}>
                            <DayPicker
                                {...dateField(form(['startDate', 'endDate']))} />
                            <TimeRangePicker 
                                {...dateRangeField(form(['startDate', 'endDate']))} />
                        </div>
                    </div>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.validate}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

ScheduleInterventionModal = connectForm({
    target: 'cmd',
    schema: ScheduleInterventionCmd.schema,
    action: SCHEDULE_INTERVENTION_CMD_UPDATED
})(ScheduleInterventionModal)

ScheduleInterventionModal = connect((state) => ({
    cmd: state.ticket.scheduleInterventionCmd
}))(ScheduleInterventionModal)

export default ScheduleInterventionModal


// WEBPACK FOOTER //
// ./lib/ticket/components/ScheduleInterventionModal.js